export default function AboutEditor({ content, storyDraft, saving, onChange, onStoryChange, onStatChange, onSubmit }) {
  return (
    <form className="admin-editor" onSubmit={onSubmit}>
      <div className="admin-editor-heading">
        <div>
          <p className="admin-kicker">Page content</p>
          <h2>About page</h2>
          <p>Changes are published immediately. Separate story paragraphs with a blank line.</p>
        </div>
        <a href="/about" target="_blank" rel="noopener noreferrer">View page</a>
      </div>
      <label>Kicker<input value={content.kicker} onChange={(event) => onChange("kicker", event.target.value)} required /></label>
      <label>Page title<input value={content.title} onChange={(event) => onChange("title", event.target.value)} required /></label>
      <label>Introduction<textarea rows="7" value={content.intro} onChange={(event) => onChange("intro", event.target.value)} required /></label>
      <div className="admin-stat-grid">
        {content.stats.map((stat, index) => (
          <fieldset key={index}>
            <legend>Highlight {index + 1}</legend>
            <label>Value<input value={stat.value} onChange={(event) => onStatChange(index, "value", event.target.value)} required /></label>
            <label>Label<input value={stat.label} onChange={(event) => onStatChange(index, "label", event.target.value)} required /></label>
          </fieldset>
        ))}
      </div>
      <label>Story heading<input value={content.storyTitle} onChange={(event) => onChange("storyTitle", event.target.value)} required /></label>
      <label>Story paragraphs<textarea rows="14" value={storyDraft} onChange={(event) => onStoryChange(event.target.value)} required /></label>
      <label>Image URL<input type="url" value={content.imageUrl} onChange={(event) => onChange("imageUrl", event.target.value)} required /></label>
      <label>Image description<input value={content.imageAlt} onChange={(event) => onChange("imageAlt", event.target.value)} required /></label>
      <button className="admin-primary" disabled={saving}>{saving ? "Publishing…" : "Publish About page"}</button>
    </form>
  );
}
